import React from 'react'
import { Form as SemanticForm } from 'semantic-ui-react'

export const Form = props => <SemanticForm {...props} />

Form.Field = props => <SemanticForm.Field {...props} />
